<template>
  <div class="Settings">
    <ld-header @click-right="newConsole">
      <span @click="interpret">
        {{ $t('A109','设置') }}
      </span>
      <template #right>
        &nbsp;
      </template>
    </ld-header>
    <div class="list">
      <van-cell
        :title="$t('Q306','账户绑定手机')"
        :value="userInfo.empInfo.phoneNumber"
        @click="modifyMobile"
        is-link
      />
      <van-cell
        :title="$t('Q307','登录密码')"
        to="/userCenter/settings/modifyPassword"
      >
        <span class="main-color">{{ $t('G013','修改密码') }}</span>
      </van-cell>
    </div>

    <div class="list">
      <van-cell
        :title="$t('language','切换语言')"
        @click="showMenu = true"
        v-model="locale"
        is-link
      /> 
      <!-- <van-cell
        title="最近登陆历史"
        @click="loginHistory"
        is-link
      /> -->
      <van-cell
        center
        title="消息推送"
        v-show="isH5()==false"
      >
        <template #right-icon>
          <van-switch
            v-model="push"
            @change="pushChange"
            size="22"
          />
        </template>
      </van-cell>
      <van-cell
        title="首页风格"
        is-link
        v-if="loginConfig.by4=='QHHK'"
        @click="showHomePage=true"
      >
        {{ homeTypeName }}
      </van-cell>
    </div>

    <div class="list">
      <van-cell
        :title="$t('Clear','清除缓存')"
        @click="clearCache()"
        is-link
      />
      <van-cell
        is-link
        title="清空推送消息"
        v-show="isH5()==false"
        @click="clearMsg"
      />
      <van-cell
        title="注销账号"
        @click="closeAccount"
        is-link
      />
    </div>
    <van-cell
      :title="$t('A116','关于我们')"
      to="/userCenter/settings/about"
      is-link
    /> 

    <div class="quit_btn">
      <ld-button
        main2
        round
        @click="login_out()"
      >
        {{ $t('B023','退出当前账号') }}
      </ld-button>
    </div>

    <!--  -->
    <van-action-sheet
      title="选择语言"
      :cancel-text="$t('B008','取消')"
      :actions="menus"
      v-model="showMenu"
      @select="changeLocale"
      @cancel="showMenu = false"
    />
    <!--  -->
    <van-action-sheet
      v-model="showHomePage"
      title="选择首页风格"
      :cancel-text="$t('B008','取消')"
      close-on-click-action
      :actions="homePages"
      @select="changeHomePage"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ldHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import { Cell , CellGroup ,ActionSheet ,Switch } from 'vant'
import { localremove,sessionremove,localset,localget } from 'Utils/storage.js'
import VConsole from 'vconsole'
import { openWebview,isH5 } from 'CommonUtils/plus.js'
import { clearMessage } from 'CommonUtils/push.js'

export default {
  name:'Setting',
  components: {
    ldHeader,
    ldButton,
    [CellGroup.name]:CellGroup,
    [Cell.name]:Cell,
    [ActionSheet.name]:ActionSheet,
    [Switch.name]:Switch,
  },
  data () {
    return {
      showMenu: false,
      menus: [
        {name:'中文', key:'zh-CN'},
        {name:'English', key:'en-US'}
      ],
      push:'',
      showHomePage:false,
      homePages: [
        {name:'四方格式', key:'2'},
        {name:'图标式', key:'1'},
      ],
      homeTypeName:'图标式'
    }
  },
  created(){
    this.push=this.isPush
    var homeType=localget('homeType')
    if(homeType==1){
      this.homeTypeName='图标式'
    }else if(homeType==2){
      this.homeTypeName='四方格式'
    }else{
      this.homeTypeName='图标式'
    }
  },
  methods: {
    isH5,
    // 隐藏功能 调试专用
    interpret () {
      var ip = window.prompt('请输入需调试的本机的项目地址IP')
      if (ip != null && ip != '') {
        ip = ip.indexOf('//') > -1 ? ip : `//${ip}`
        openWebview(ip)
      }
    },
    newConsole () {
      window.vConsole = new VConsole()
    },
    // 清除缓存
    clearCache () {
      this.$dialog.confirm({
        title:this.$t('C474','提示'),
        message: '清除缓存后需要重新登录！'
      }).then(() => {
        sessionremove('VUEX_STATE')
        localremove('access_token')
        localremove('userInfo')
        localremove('VUEX_STATE')
        localremove('geo_10901_zh-CN')
        localremove('geo_10902_zh-CN')
        localremove('geo_10903_zh-CN')
        localremove('geo_10904_zh-CN')
        this.$dialog.alert({
          title: this.$t('C474','提示'),
          message: '清除成功！'
        })
      })
    },
    // 切换语言
    changeLocale (locale) {
      this.$i18n.set(locale.key)
      this.showMenu=false
    },
    // 退出登录
    login_out () {
      let self=this
      self.$dialog.confirm({
        message: '请确认退出？'
      }).then(() => {
        self.$store.dispatch('loginOut').then(()=>{
          self.$router.push('/login') 
        }).catch(()=>{
          self.$router.push('/login') 
        })
      })
    },
    // 开关消息推送
    pushChange(){
      this.$store.commit('SET_PUSH',this.push)
    },
    // 清除推送消息
    clearMsg(){
      this.$dialog.confirm({
        title: '提示',
        message: '确认清空消息？',
      }).then(() => {
        clearMessage()
        // on confirm
      }).catch(() => {
        // on cancel
      })
    },
    async modifyMobile () {
      let { data = {} } = await this.$api['common/getParameter']({paramNo: 11605005})
      let value1 = data.value1
      if (value1 == 1) {
        this.$router.push('/userCenter/settings/modifyMobile')
      } else {
        this.$dialog.alert({
          message: this.$t('F596','未开放员工自行修改手机号的权限，请联系管理员处理！')
        })
      }
    },
    //注销账户
    closeAccount(){
      this.$router.push('/userCenter/settings/closeAccount')
    },
    // 登录历史
    loginHistory(){
      this.$router.push('/userCenter/settings/closeAccount')
    },
    changeHomePage(item){
      this.homeTypeName=item.name
      localset('homeType',item.key)
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo',
      isPush:'isPush',
      loginConfig:'loginConfig'
    }),
    locale(){
      if(this.$i18n.locale()=='zh-CN'){
        return '中文'
      }
      return 'English'
    }
  }
}
</script>

<style lang="less" scoped>
.Settings {
  .quit_btn {
    position: fixed;
    width: 100%;
    bottom: .52rem;
    padding: 0 .74rem;
  }
  .list{
      padding-bottom: 5px;
  }
}
</style>


